import {
  GET_CUSTOMER_REQUEST,
  GET_CUSTOMER_WITH_DEFAULTS_REQUEST,
  LOGIN_REQUEST,
  FB_LOGIN_OR_CREATE_REQUEST,
  GOOGLE_LOGIN_OR_CREATE_REQUEST,
  LOGOUT_REQUEST,
  FORGOT_PASSWORD_REQUEST,
  MAGIC_LINK_REQUEST,
  MAGIC_LINK_ID_REQUEST,
  ADD_CUSTOMER_REQUEST,
  ADD_CUSTOMER_WITH_ADDRESS_REQUEST,
  EDIT_CUSTOMER_REQUEST,
  EDIT_PASSWORD_REQUEST,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_ID_REQUEST,
  UNSUBSCRIBE_CUSTOMER_REQUEST
} from './constants';

export const unsubscribe = (customerId, payload, successFunction) => ({
  type: UNSUBSCRIBE_CUSTOMER_REQUEST,
  customerId,
  payload,
  successFunction
});

export const getCustomer = () => ({ type: GET_CUSTOMER_REQUEST });

export const getCustomerWithDefaults = () => ({
  type: GET_CUSTOMER_WITH_DEFAULTS_REQUEST
});

export const addCustomer = (customer, successFunction) => ({
  type: ADD_CUSTOMER_REQUEST,
  customer,
  successFunction
});

export const addCustomerWithAddress = (customer, successFunction) => ({
  type: ADD_CUSTOMER_WITH_ADDRESS_REQUEST,
  customer,
  successFunction
});

export const editCustomer = (customer, successFunction) => ({
  type: EDIT_CUSTOMER_REQUEST,
  customer,
  successFunction
});

export const editPassword = (customer, successFunction) => ({
  type: EDIT_PASSWORD_REQUEST,
  customer,
  successFunction
});

export const login = (email, password, successFunction, errorFunction) => ({
  type: LOGIN_REQUEST,
  email,
  password,
  successFunction,
  errorFunction
});

export const fbLoginOrCreate = (
  accessToken,
  successFunction,
  errorFunction
) => ({
  type: FB_LOGIN_OR_CREATE_REQUEST,
  accessToken,
  successFunction,
  errorFunction
});

export const googleLoginOrCreate = (
  tokenId,
  successFunction,
  errorFunction
) => ({
  type: GOOGLE_LOGIN_OR_CREATE_REQUEST,
  tokenId,
  successFunction,
  errorFunction
});

export const forgotPassword = (data, successFunction, errorFunction) => ({
  type: FORGOT_PASSWORD_REQUEST,
  data,
  successFunction,
  errorFunction
});

export const resetPassword = (resetObj, successFunction) => ({
  type: RESET_PASSWORD_REQUEST,
  resetObj,
  successFunction
});

export const magicLink = (data, successFunction, errorFunction) => ({
  type: MAGIC_LINK_REQUEST,
  data,
  successFunction,
  errorFunction
});

export const validateResetPasswordId = (
  resetPasswordId,
  emailId,
  errorFunction
) => ({
  type: RESET_PASSWORD_ID_REQUEST,
  errorFunction,
  resetPasswordId,
  emailId
});

export const validateMagicLinkId = (
  magicLinkId,
  successFunction,
  errorFunction
) => ({
  type: MAGIC_LINK_ID_REQUEST,
  errorFunction,
  successFunction,
  magicLinkId
});

export const logout = () => ({
  type: LOGOUT_REQUEST
});
